<section>
  <div class="chat-body">
    <div class="chat-tabs">
      @if (onlyDialogTab) {
        @if (isTenantInvolved) {
          <div class="tenant-checkbox">
            <astral-checkbox [control]="checkOnlyForTenantControl" (valueChange)="onTenantFilterChange()"></astral-checkbox>
          </div>
        }
        <div class="chat-content" #chatContent>
          <!-- Messages are loaded -->
          @if (dialogMessages) {
            <!-- Render messages -->
            @for (item of chatInfo; track item; let i = $index) {
              <p class="day-note">{{ item.stringRepresentation }}</p>
              @for (message of item.chatMessages; track message; let j = $index) {
                <app-chat-message
                  [index]="j"
                  [dialogMessage]="message"
                  [dialogEndpoint]="dialogEndpoint"
                  (delete)="handleMessageDelete($event)"
                  [messageCheckAsReadBlocked]="messageCheckAsReadBlocked"
                  [isTenantInvolved]="isTenantInvolved"
                ></app-chat-message>
              }
              @if (i !== chatInfo.length - 1) {
                <hr />
              }
            }
          }
        </div>
        @if (hasMessageInput) {
          <div class="dialog-message-input" #dialogMessageInput>
            <app-chat-input-message
              [dialogId]="dialogId"
              [dialogEndpoint]="dialogEndpoint"
              (messageSent)="handleMessageSent()"
              [visibleForTenantCheckbox]="visibleForTenantCheckbox"
              [isTenantInvolved]="isTenantInvolved"
            ></app-chat-input-message>
          </div>
        }
      }

      @if (!onlyDialogTab) {
        <app-tab-group>
          <!-- Messages Tab -->
          <app-tab label="{{ 'CHAT.TABS.FOLLOW_CASE_TAB' | translate }}">
            @if (isTenantInvolved) {
              <div class="tenant-checkbox">
              <astral-checkbox [control]="checkOnlyForTenantControl" (valueChange)="onTenantFilterChange()"></astral-checkbox>
              </div>
            }
            <div class="chat-content" #chatContent>
              <!-- Messages are loaded -->
              @if (dialogMessages) {
                <!-- Render messages -->
                @for (item of chatInfo; track item; let i = $index) {
                  <p class="day-note">{{ item.stringRepresentation }}</p>
                  @for (message of item.chatMessages; track message; let j = $index) {
                    <app-chat-message
                      [index]="j"
                      [dialogMessage]="message"
                      [dialogEndpoint]="dialogEndpoint"
                      (delete)="handleMessageDelete($event)"
                      [messageCheckAsReadBlocked]="messageCheckAsReadBlocked"
                      [isTenantInvolved]="isTenantInvolved"
                    ></app-chat-message>
                  }
                  @if (i !== chatInfo.length - 1) {
                    <hr />
                  }
                }
              }
            </div>
            @if (hasMessageInput) {
              <div class="dialog-message-input" #dialogMessageInput>
                <app-chat-input-message
                  [dialogId]="dialogId"
                  [dialogEndpoint]="dialogEndpoint"
                  (messageSent)="handleMessageSent()"
                  [visibleForTenantCheckbox]="visibleForTenantCheckbox"
                  [isTenantInvolved]="isTenantInvolved"
                ></app-chat-input-message>
              </div>
            }
          </app-tab>
          <!-- Files Tab -->
          <app-tab
            label="{{
              files.length > 0 ? ('CHAT.TABS.FILES_TAB' | translate: { count: files.length }) : ('CHAT.TABS.FILES_TAB_EMPTY' | translate)
            }}"
            >
            @if (dialogMessages) {
              @if (files.length === 0) {
                <div class="no-files-block">
                  <div class="image-block">
                    <img src="assets/icons/component_icons/no-file-main.png" />
                  </div>
                  <div class="text-block">
                    <h4>{{ 'CHAT.FILES.NO_FILES_HEADER' | translate }}</h4>
                    <p>{{ 'CHAT.FILES.NO_FILES_TEXT' | translate }}</p>
                  </div>
                </div>
              }
              @if (files.length > 0) {
                <app-chat-message-files [files]="files"></app-chat-message-files>
              }
            }
          </app-tab>
          <!-- TODO: additional tab. Could be uncommented in future -->
          <!-- History Tab -->
          <!-- <mat-tab label="{{ 'CHAT.TABS.HISTORY_TAB' | translate }}">NO CONTENT</mat-tab> -->
        </app-tab-group>
      }
    </div>
  </div>
</section>
